import React from 'react';

import Article from '../../../Api/Models/Article';
import i18n from '../../../base/i18n';
import useGlobalState from '../../GlobalStateContext';

function ArticleSlugLink({ article }: { article: Article }) {
    const { languages } = useGlobalState();
    const locale = languages.filter((lang) => lang.id === article?.language_id)[0]?.code;
    const getPlainText = () => <>{article?.slug ?? '\u2014'}</>;

    if (!locale) {
        return getPlainText();
    }

    const url = article.is_partial ? mapPartialArticleSlug(article.slug, locale) : article.slug;

    if (url == null) {
        return getPlainText();
    }

    return (
        <a href={new URL(`/${locale}/${url}`, window.location.href).href} target="_blank" rel="noreferrer">
            {article.slug}
        </a>
    );
}

function mapPartialArticleSlug(slug: string, locale: string): string | null {
    const r = (id: string) => i18n.t(`routes.${id}`, { lng: locale });

    const mapPatterns: Array<[RegExp, (found: RegExpExecArray) => string]> = [
        [/^footer-info$/, () => ''],
        [/^my-account$/, () => 'account'],
        [/^deposit$/, () => 'account/deposit'],
        [/^withdrawal$/, () => 'account/withdrawal'],
        [/^refer$/, () => 'refer'],
        [/^reseller-system-(description|regulations)$/, () => 'agents-registration'],
        [/^reseller-system-about$/, () => 'agents/about'],
        [/^results\.all$/, () => r('results_all')],
        [/^rules\.all$/, () => r('rules_all')],
        [/^contact$/, () => r('contact')],
        [/^become-an-affiliate$/, () => r('become_an_affiliate_contact')],
        [/^how-to-play$/, () => r('how_to_play_all')],
        [/^how-to-play-(.+)$/, (found) => `${r('how_to_play_all')}/${found[1]}`],
        [/^(.+)_play-(top|bottom)$/, (found) => `${r('play_all')}/${found[1]}`],
        [/^(.+)_results-(top|bottom)$/, (found) => `${r('results_all')}/${found[1]}`],
        [/^(.+)_rules-(top|bottom)$/, (found) => `${r('rules_all')}/${found[1]}`],
    ];

    for (let i = 0; i < mapPatterns.length; i++) {
        const found = mapPatterns[i][0].exec(slug);

        if (found) {
            return mapPatterns[i][1](found);
        }
    }

    return null;
}

export default ArticleSlugLink;
